import React, { Component } from "react";
import _ from "lodash";
import { CircularProgressbar } from "react-circular-progressbar";

import Page from "./page";
import "./Orders.scss";
import "react-circular-progressbar/dist/styles.css";
import "./Ticker.scss";
import { api } from "../../config";

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: [],
      lines: [],
      dates: [],
      page: [0],
      timer: 0,
      ticker: 10000,
      itteration: 0,
      jump: 1000,
    };
    this.force = this.force.bind(this);
  }

  componentDidMount() {
    this.loadData();

    let dataload = setInterval(this.loadData.bind(this), 1000 * 60 * 5);
    this.setState({ dataload: dataload });

    document.addEventListener("keydown", this.force, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.force, false);
    // use intervalId from the state to clear the interval
    clearInterval(this.state.dataload);
    clearInterval(this.state.intervalId);
    clearInterval(this.state.ticksave);
  }

  ticker() {
    let iteration = this.state.itteration;
    let tick = this.state.ticker - this.state.jump;
    iteration = iteration + this.state.jump;
    this.setState({ timer: (iteration / tick) * 100, itteration: iteration });
  }

  pageswitch(backwards) {
    if (
      (this.state.page[0] === this.state.page.length ||
        this.state.lines.length === 0) &&
      !backwards
    ) {
      this.props.next(true);
    } else if (backwards && this.state.page[0] === 1) {
      this.props.next(false);
    }
    if (backwards) {
      let ara = this.state.show;
      ara.push(ara.splice(0, 1)[0]);
      this.setState({ show: ara });
      let date = this.state.dates;
      date.unshift(date.pop());
      this.setState({ dates: date });
      let pages = this.state.page;
      pages.unshift(pages.pop());
      this.setState({ page: pages });
      this.setState({ itteration: 0, timer: 0 });
    } else {
      let ara = this.state.show;
      ara.unshift(ara.pop());
      this.setState({ show: ara });
      let date = this.state.dates;
      date.push(date.splice(0, 1)[0]);
      this.setState({ dates: date });
      let pages = this.state.page;
      pages.push(pages.splice(0, 1)[0]);
      this.setState({ page: pages });
      this.setState({ itteration: 0, timer: 0 });
    }
  }

  async loadData() {
    clearInterval(this.state.intervalId);
    clearInterval(this.state.ticksave);
    fetch(api + "/plugins/delibert/getCastOrders")
      .then((res) => res.json())
      .then((response) => {
        const filt = this.props.filter;
        let arset = response;
        if (filt > "") {
          arset = arset.filter((e) => {
            return e.keuken === filt;
          });
        }
        if (arset.length > 0) {
          let today = this.slice(arset);
          this.setState({ show: today.val });
          this.setState({ lines: today.result });
          this.setState({ dates: today.dates });
          this.setState({ page: today.page });

          let ticksave = setInterval(this.ticker.bind(this), this.state.jump);
          let intervalId = setInterval(
            this.pageswitch.bind(this),
            this.state.ticker
          );
          // store intervalId in the state so it can be accessed later:
          this.setState({
            intervalId: intervalId,
            ticksave: ticksave,
            itteration: 0,
          });
        } else {
          this.props.next(true);
        }
      })
      .catch((error) => console.error("Error:", error));
  }

  force(e) {
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
      clearInterval(this.state.intervalId);
      clearInterval(this.state.ticksave);
      this.setState({ itteration: 0, timer: 0 });
      if (e.key === "ArrowLeft") {
        this.pageswitch(true);
      } else {
        this.pageswitch(false);
      }
      let ticksave = setInterval(this.ticker.bind(this), this.state.jump);
      let intervalId = setInterval(
        this.pageswitch.bind(this),
        this.state.ticker
      );
      // store intervalId in the state so it can be accessed later:
      this.setState({ intervalId: intervalId, ticksave: ticksave });
    }
  }

  slice(arr) {
    let dates = _.toArray(_.groupBy(arr, "order_delivery_moment"));
    let show = [];
    let page = [];
    let lines = [];
    let date = [];
    dates.forEach((date) => {
      let slice = (source, index) => source.slice(index, index + 8);
      let length = date.length;
      let index = 0;
      let result = [];
      while (index < length) {
        let temp = slice(date, index);
        result.push(temp);
        index += 8;
      }
      lines.push(result);
    });
    let currentpage = 1;
    lines.forEach((line, i) => {
      line.forEach((e, x) => {
        var parts = e[0].order_delivery_moment.split("-");
        var time = new Date(
          parseInt(parts[2], 10),
          parseInt(parts[1], 10) - 1,
          parseInt(parts[0], 10)
        );
        var locale = "nl-NL";

        var DD = time.getDate();
        var DDD = time.toLocaleString(locale, { weekday: "long" });
        var MMM = time.toLocaleString(locale, { month: "long" });
        if (i === 0 && x === 0) {
          show.push(true);
        } else {
          show.push(false);
        }
        page.push(currentpage++);
        date.push(
          e[0].dag +
            " " +
            DDD.charAt(0) +
            DDD.slice(1) +
            " " +
            DD +
            " " +
            MMM.charAt(0).toUpperCase() +
            MMM.slice(1)
        );
      });
    });
    let data = { result: lines, val: show, dates: date, page: page };
    return data;
  }

  render() {
    let iteration = -1;
    return (
      <div key="order" className={"app " + this.props.color}>
        <div className="pages">
          <CircularProgressbar
            key={this.state.page}
            className="fast-animation"
            value={this.state.timer}
            initialAnimation={true}
            text={this.state.page[0] + "/" + this.state.page.length}
          />
          <div className="pagecounter" />
        </div>
        <div className="dateswitch">
          <div className="rounded">{this.state.dates[0]}</div>
        </div>
        <div className="holder">
          <div className="header">
            <div className="blocks show firstblock">
              <span>Order</span>
            </div>
            <div className="blocks show sevenblock">
              <span>Keuken</span>
            </div>
            <div className="blocks show secondblock">
              <span>Klant</span>
            </div>
            <div className="blocks show thirdblock">
              <span />
            </div>
            <div className="blocks show fourthblock">
              <span>Stuks</span>
            </div>
            <div className="blocks show fifthblock">
              <span>Klaar</span>
            </div>
            <div className="blocks show sixthblock">
              <span />
            </div>
          </div>
          {this.state.lines.map((dates, i) => {
            return dates.map((pagedata, i) => {
              iteration++;
              return (
                <Page
                  key={i}
                  show={this.state.show[iteration]}
                  data={pagedata}
                />
              );
            });
          })}
        </div>
      </div>
    );
  }
}

export default Orders;
